import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Brand Schema
 * Represents a brand that can be promoted by affiliates
 * Base schema is loose to allow loading legacy data.
 */
export const BrandSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    name: Yup.string().nullable(),
    nameEng: Yup.string().nullable(),
    imgThumbnail: Yup.string().nullable(),
    imgLarge: Yup.string().nullable(),
    isRecommended: Yup.boolean().default(false),
    recommendedDate: Yup.date().nullable(),
    createdAt: Yup.date().nullable(),
    updatedAt: Yup.date().nullable(),
  })

/**
 * Brand Validation Schema
 * Strict rules applied only during form submission.
 */
export const BrandValidationSchema = BrandSchema.clone().shape({
  id: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  name: Yup.string().required(ERROR_MESSAGES.BRAND_NAME_REQUIRED),
  nameEng: Yup.string().required(ERROR_MESSAGES.NAME_ENG_REQUIRED),
})
